import React from 'react'

const Footer = () => {
  return (
    <p className='py-4 border-t-2 border-blue flex justify-center text-sm'>© 2024 ahmed abd al karem. All right reserved</p>
  )
}

export default Footer